import API from '../api';

// function to get single invitation data
export const getPlaceData = async (domain: string) => {
  let response = await API.get(`/places/data/${domain}`);
  return response.data;
}